module.exports = __webpack_public_path__ + "img/supplier-pc.73bc80a.webp";